import Evaluations from '../views/Evaluations';

const router = [
  {
    name: 'evaluations',
    path: '/evaluations',
    component: Evaluations,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/app/evaluations/router/index.js